import { render, staticRenderFns } from "./closeWindow.vue?vue&type=template&id=e86fd906&"
import script from "./closeWindow.vue?vue&type=script&lang=js&"
export * from "./closeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports